/**
 * KPI([kpi], [period], [scenario]) argument tokens. The canonical period keys
 * are the metrics row's kpiData bucket keys ('Month'), the canonical scenario
 * keys its section keys ('actual') — evaluation joins them straight into the
 * resolution path "<kpi ref>.<Period>.<section>.value". Matching is
 * case-insensitive so hand-typed display forms ([quarter], [Actual])
 * canonicalize to the same tokens.
 */
export const KPI_PERIOD_KEYS = ['Month', 'Quarter', 'Year'] as const;
export type KpiPeriodKey = (typeof KPI_PERIOD_KEYS)[number];

export const KPI_SECTION_KEYS = ['actual', 'budget'] as const;
export type KpiSectionKey = (typeof KPI_SECTION_KEYS)[number];

export function canonicalKpiPeriod(ref: string): KpiPeriodKey | undefined {
  const lower = ref.trim().toLowerCase();
  return KPI_PERIOD_KEYS.find((key) => key.toLowerCase() === lower);
}

export function canonicalKpiSection(ref: string): KpiSectionKey | undefined {
  const lower = ref.trim().toLowerCase();
  return KPI_SECTION_KEYS.find((key) => key === lower);
}

/** The scenario tokens as shown to users ("actual" → "Actual"). */
export function kpiSectionLabel(key: string): string {
  return key === 'actual' ? 'Actual' : key === 'budget' ? 'Budget' : key;
}
